<template>
	<div>
		<Modal v-model="visiable" :title="title" :closable="false" :mask-closable="false">
			<div slot="header" class="modal-header">
				<!-- <Icon class="close" type="md-close" @click="cancel" /> -->
				<span>{{title}}</span>
			</div>
			<div class='mian'>
				<p v-html="desc"></p>
				<div class="forInput" v-if='type==0'>

					<Row>
						<Col v-for="(item,index) in forData" span="24">
						<template v-if='item.type=="input"'>
							<div class="cell">
								<label :class="{ 'required': item.require }">{{item.name}}</label>
								<Input class="input" v-model='item.dvalue' :placeholder="item.name"></Input>
							</div>
						</template>
						<template v-if='item.type=="radio"'>
							<div class="cell">
								<label :class="{ 'required': item.require }">{{item.name}}</label>
								<RadioGroup :class="radio" v-model="item.dvalue">
									<Radio :key="item.code" v-for="(item,index1) in item.value" v-model="item.code" :label="item.text"></Radio>
								</RadioGroup>
							</div>
						</template>
						<template v-if='item.type=="checkbox"'>
							<div class="cell">
								<template v-if="item.agree">
									<CheckboxGroup class="checkbox" v-model="item.dvalue">
										<Checkbox v-for="(item,index1) in item.value" :key='item.code' :label="item.text"></Checkbox>
									</CheckboxGroup>
									<span @click="open(item)" :class="{ 'required': item.require }" v-html="item.name"> {{item.name}}</span>
								</template>
								<template v-else>
									<label :class="{ 'required': item.require }">{{item.name}}</label>
									<CheckboxGroup class="checkbox" v-model="item.dvalue">
										<Checkbox v-for="(item,index1) in item.value" :key='item.code' :label="item.text"></Checkbox>
									</CheckboxGroup>
								</template>
							</div>
						</template>
						<template v-if='item.type=="dropdown"'>
							<div class="cell">
								<label :class="{ 'required': item.require }">{{item.name}}</label>
								<Select class="select" v-model="item.dvalue">
									<Option v-for="(item,index1) in item.value" :value="item.code" :key="item.code">{{ item.text }}</Option>
								</Select>
							</div>
						</template>
						<template v-if='item.type=="agree"'>
							<div class="cell">
								<div v-for="(item1,index1) in item.value">
									<Checkbox v-model="item.dvalue"></Checkbox>
									<span v-html="item1.text" @click.prevent="oepnDoubt(item1.action)"></span>
								</div>
							</div>
						</template>
						</Col>
					</Row>

				</div>
				<div class="forInfo" v-if='type==1'>

				</div>

			</div>
			<div slot="footer">
				<!-- <Button size="large" @click="cancel">取消(cancel)</Button> -->
				<Button :loading='loadBtn' type="primary" size="large" @click="confirm">確認(confirm)</Button>
			</div>

		</Modal>
		<Modal :title=title :closable='false' :mask-closable='false' :scrollable='true' :styles="{top:'20px'}" width="835" v-model="alertvalue">
			<div id='content' v-html='content'>

			</div>
			<div class="bottom-button">
				<Button @click='close(false)' class='goon-btn' size='large' type='primary'>返回(back)</Button>
			</div>
			<div slot="footer" style='text-align: center;'>

			</div>
		</Modal>
	</div>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import agreementView from "@/components/order/agreementView";
export default {
	data() {
		return {
			alertvalue: false,
			code: null,
			visiable: false,
			doubtKey: {},
			title: null,
			desc: null,
			survey: null,
			type: 0, ///0 input 1信息框

			forData: [],

			loadBtn: false,
			content: null,

			ruleValidate: {
				required: [
					{
						required: true,
						message: "這是必填區域",
						trigger: "blur",
					},
					// {validator:async(rule, value, callback, source, options)=> {
					// 	if (!value) {
					// 		callback({message:'這是必填區域'});
					// 	}else {
					// 		callback([]);
					// 	}
					// },trigger: 'blur'}
				],
			},
		};
	},
	computed: {},
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		model: {
			type: Object,
			default: null,
		},
	},
	components: [agreementView],
	watch: {
		value(val) {
			if (val) {
				this.initData();
			}
			console.log("visiable", val);
			this.visiable = val;
		},
	},
	mounted() {},
	methods: {
		...mapActions(["postSpecInfoAction", "getTipDetailAction",'updateCartAction']),
		...mapMutations(['ADD_CART']),
		initData() {
			this.survey = this.model;
			this.title = this.survey.Name;
			this.desc = this.survey.Description;
			var action = this.survey.Action.toLowerCase();
			if (action == "input") {
				this.type = 0;
				this.forData = JSON.parse(this.survey.ActionObject1);
				console.log("forData", this.forData);
			}
			if (action == "info") {
				this.type = 1;
			}
		},
		check(dvalue) {
			if (!dvalue || dvalue == "") {
				return false;
			}
			return true;
		},
		async confirm() {
			this.loadBtn = true;
			var copyforData = JSON.parse(JSON.stringify(this.forData));
			//var copyforData = Object.assign(this.forData, []);
			var result = true;
			copyforData.forEach((item, index) => {
				if (item.require) {
					if (!this.check(item.dvalue || "")) {
						this.$Message.error(item.name + ",必填項");
						result = false;
					} else if (item.type == "checkbox") {
						item.dvalue = item.dvalue.join(",");
					}
				}
			});
			if (result) {
				if (this.survey.Code == "OD-XSY") {
					var model = this.survey.surveyProduct;
					this.ADD_CART({ ...model});
					this.updateCart(model.sku,model.product_number||1)
					this.cancel();
				} else {
					var OrderNo = this.survey.os;
					var Code = this.survey.Code;
					var params = {
						OrderNo,
						Code: Code,
						SpecInfo: copyforData,
					};

					var res = await this.postSpecInfoAction(params);
					if (typeof res === "number") {
						this.$router.push({
							path: "/order/payment",
							query: {
								orderno: this.survey.orderno,
								os: this.survey.os,
							},
						});
					} else {
						this.$Modal.error({
							title: "錯誤 (error)",
							content: "提交失敗,請重新嘗試",
							okText: "確定",
							onOk: () => {
								//this.$router.push("/order/product");
							},
						});
					}
				}
			}
			this.loadBtn = false;
		},
		async oepnDoubt(code) {
			var content = null;
			if (this.doubtKey[code]) {
				content = this.doubtKey[code];
			} else {
				var res = await this.getTipDetailAction(code);
				if (res) {
					content = res.Content;
					this.doubtKey[code] = content;
				}
			}
			this.content = content;
			this.alertvalue = true;
		},
		close() {
			this.alertvalue = false;
		},
		cancel() {
			this.$emit("showSurveyfun");
		},
		updateCart(sku, num) {
			var params = {
				//customerId:this.getUserId,
				sku,
				num,
			};
			this.updateCartAction(params);
		},
	},
};
</script>
<style lang='scss' scoped>
.mian {
	& > p {
		margin-bottom: 10px;
	}
}
.cell {
	margin-bottom: 10px;
	& > label {
		display: block;
		margin-bottom: 5px;
		&.required::before {
			content: "*";
			display: inline-block;
			margin-right: 4px;
			line-height: 1;
			font-family: SimSun;
			font-size: 12px;
			color: #ed3f14;
		}
	}
	.radio {
		width: 100%;
		display: inline-block;
	}
	.input {
		width: 100%;
	}
	.checkbox {
		width: auto;
		display: inline-block;
	}
	.select {
		width: auto;
		width: 100%;
	}
}
.modal-header {
	padding: 10px;
	border: none;
	padding-bottom: 0;
	//padding-left: 30px;
	background-color: #fff;
	//height: 55px;
	.close {
		color: #354657;
		float: right;
		font-size: 22px;
		cursor: pointer;
		position: relative;
		top: -5px;
	}
}
</style>